<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :before-close="closeFn" :destroy-on-close="true" width="680px">
      <div class="box">
        <div class="title">微信扫码，联系商务人员进行业务咨询</div>
        <img :src="i1" alt="" class="img">
        <div class="scal">微信扫一扫</div>
        <div class="phone">联系电话：0755-29739988   0755-29001122</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i1 from '../assets/images/amusement/1.png'
export default {
  name: 'dialogBusiness',
  data () {
    return {
      i1: i1
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeFn () {
      this.modalShow = false
      this.$emit('dialogVisible', false)
    }
  },
  watch: {
    modalShow () {
      this.$emit('dialogVisible', false)
    }
  }
}
</script>

<style scoped>
  .box{
    width: 500px;
    background: #ffffff;
    margin: auto;
  }
  .title{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:28px;
    color:rgba(0,0,0,1);
    margin-bottom: 26px;
  }
  .scal{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    line-height:28px;
    color:rgba(102,102,102,1);
    margin-bottom: 18px;
  }
  .phone{
    font-size:20px;
    font-family:DIN;
    font-weight:500;
    line-height:28px;
    color:rgba(51,51,51,1);
    margin-bottom: 22px;
  }
  .img{
    width: 294px;
    height:294px;
    margin-bottom: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogBusiness.vue